<div
    class="driver-detail-container flex flex-column gap-4 justify-content-center align-items-center"
>
    <p-card
        class="w-full"
        *ngIf="driver"
    >
        <ng-container #title>
            <div class="mb-4 flex align-items-center gap-3 justify-content-start">
                <p-button (click)="goToDriversListing()" icon="pi pi-arrow-left" [rounded]="true" [raised]="true" [text]="true" severity="danger" />
                <span class="p-card-title mb-0">{{"DRIVER_DETAILS" | translate}}</span>
            </div>
        </ng-container>
        <ng-container #subtitle *ngIf="driver.driver.kycStatus === 'NON_COMPLIANT'">
            <div class="mb-4 flex align-items-center gap-3 justify-content-start">
                <p-message severity="warn" text="To complete Driver Registration Upload required documents below"></p-message>
            </div>
        </ng-container>
        <div class="border-300 border-top-1 surface-border pt-4 flex flex-column">
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{ driver.driver.firstname }}</span>
                    <span class="text-500 text-sm">{{
                        "FIRST_NAME" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{ driver.driver.surname }} </span>
                    <span class="text-500 text-sm">{{
                        "LAST_NAME" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        driver.driver.dateOfBirth | date : "dd-MMM-yyyy"
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "DATE_OF_BIRTH" | translate
                    }}</span>
                </div>
                
            </div>
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        driver.driver.identificationNumber
                    }} ({{driver.driver.countryOfIDIssue}})</span>
                    <span class="text-500 text-sm">{{ convertToTitleCase(driver.driver.identificationType) | translate }}</span>
                </div>
                
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        driver.driver.nationality
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "Nationality" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-3 w-30rem">
                    <span class="text-900">{{
                        driver.driver.gender | translate
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "GENDER" | translate
                    }}</span>
                </div>
            </div>
            
            <div class="flex w-full flex-wrap">
                
                <div class="flex flex-column pb-3 w-30rem">
                    <span class="text-900">{{
                        driver.driver.status | translate
                    }}</span>
                    <span class="text-500 text-sm"
                        >{{ "DRIVER" | translate }}
                        {{ "STATUS" | translate }}</span
                    >
                </div>
            
            </div>    
        </div>
    </p-card>
    <div class="w-full" *ngIf="driver">
        <app-show-documents
            *ngIf="!(driver?.documents?.length === 0)"
            [documents]="driver.documents"
            (onUploadDocument)="onDocumentUploaded($event)"
        ></app-show-documents>
    </div>
    <div class="w-full" *ngIf="driver">
        <p-messages [(value)]="messages" [closable]="true" />
        <app-show-outstanding-documents
            *ngIf="!(driver?.outstandingDocuments?.length === 0)"
            [outstandingDocuments]="driver.outstandingDocuments"
            [identifier]="'Driver'"
            (onUploadDocument)="onDocumentUploaded($event)"
            [ownerId]="driverId"
        ></app-show-outstanding-documents>
    </div>
</div>
